const goodToKnow = {
  liquor: {
    title: "",
    text: "Vi levere dit spiritus 2-4 dage før festen, så kan det eventuelt kan komme på køl.",
    image: 15455
  },
  beer: {
    title: "",
    text: "Vi levere normalt øl og cider 2-4 dage før festen, så det hele kan nå at komme på køl.",
    image: 15452
  },
  wine: {
    title: "",
    text: "Vi levere vinen 2-4 dage før festen, så dessertvinen, champagnen og rosén kan komme på køl.",
    image: 15457
  },
  soda: {
    title: "",
    text: "Vi levere sodavanden 2-4 dage før festen, så de kan nå at komme på køl.",
    image: 15454
  },
  snacks: {
    title: "",
    text: "Dine snacks vil blive leveret 1-4 dage før festen.",
    image: 15453
  },
  tablecards: {
    title: "",
    text: "Vi levere bordkort 1-4 dage før festen.",
    image: 70407
  },
  flowers: {
    title: "",
    text: "Vi anbefaler at blomster bliver leveret 1-2 dage før festen, så de stadig er friske.",
    image: 15449
  },
  service: {
    title: "",
    text: "Vi anbefaler at det du skal bruge til borddækning bliver leveret 1-2 dage før festen.",
    image: 15450
  },
  tents: {
    title: "",
    text: "Vi anbefaler at få sat teltet op 1-2 dage før festen.",
    image: 15456
  },
  furniture: {
    title: "",
    text: "Vi levere stole 1-2 dage før festen.",
    image: 70410
  },
  musicians: {
    title: "VIDSTE DU AT",
    text: "Med live musik er det naturligt at der bliver spillet op til dans, husk at gøre plads til dansegulvet.",
    image: 15451
  },
  costumes: {
    title: "",
    text: "Vi anbefaler at få leveret udklædningen i god tid 5-10 dage før festen, så i kan sikre at hele passer.",
    image: 70409
  },
  balloons: {
    title: "",
    text: "Vi levere balloner 3-5 dage før festen.",
    image: 70406
  },
  hanging: {
    title: "",
    text: "Vi levere de hængende dekorationer 3-5 dage før festen.",
    image: 70408
  }
};

export default goodToKnow;


// WEBPACK FOOTER //
// ./src/goodToKnow.js